module.exports = __webpack_public_path__ + "static/media/horn-section.6576508c.jpg";